import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl, FormattedMessage } from "react-intl";
import {
  Segment,
  Header,
  Button,
  Loader,
  List,
  Grid,
  Icon
} from "semantic-ui-react";
import { If } from "shared/components/elements/Conditions";
import AccountRolesResource from "builder_portal/actions/accountRolesActions";
import getAccountRoles from "shared/selectors/accountRoles";
import IsVersionHistoryAccessible from "shared/components/elements/IsVersionHistoryAccessible";
import VersionHistoryLink from "shared/components/elements/VersionHistoryLink";
import AccountRoleDialog from "./AccountRoleDialog";

const AccountRoles = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const accountRoles = useSelector(getAccountRoles);
  const [isLoading, setLoading] = useState(false);

  // fetch all account roles
  useEffect(() => {
    setLoading(true);
    new AccountRolesResource(dispatch).fetchAll().then(() => setLoading(false));
  }, []);

  const renderAccountRolesList = () => {
    return (
      <>
        <If condition={isLoading === "initial"} block>
          <Loader active />
        </If>
        <If condition={!isLoading && !accountRoles.length} block>
          <FormattedMessage id="accountRoles.noRolesFound" />
        </If>
        <List divided relaxed size="large">
          {accountRoles.map(role => (
            <List.Item key={role.id}>
              <List.Content floated="right">
                <IsVersionHistoryAccessible>
                  <VersionHistoryLink id={role.id} type="AccountRole" />
                </IsVersionHistoryAccessible>
                <AccountRoleDialog
                  model={{ ...role }}
                  trigger={
                    <Button data-cmd="edit" className="icon">
                      <Icon name="setting" />
                    </Button>
                  }
                />
              </List.Content>
              <List.Content>
                <List.Header>{role.name}</List.Header>
                <List.Description>{role.description}</List.Description>
              </List.Content>
            </List.Item>
          ))}
        </List>
      </>
    );
  };

  return (
    <Segment style={{ marginTop: 0, paddingBottom: "50px" }}>
      <If condition={isLoading}>
        <Loader active style={{ marginTop: "10px" }} />
      </If>
      <If condition={!isLoading} block>
        <Grid stackable verticalAlign="middle">
          <Grid.Column width="10">
            <Header as="h3">
              <FormattedMessage id="accountRoles.title" />
            </Header>
          </Grid.Column>
          <Grid.Column textAlign="right" width="6">
            <AccountRoleDialog
              trigger={
                <Button
                  role="button"
                  id="user-new"
                  fluid
                  compact
                  icon="plus"
                  content={intl.formatMessage({
                    id: "accountRoles.actions.add"
                  })}
                />
              }
            />
          </Grid.Column>
        </Grid>
        {renderAccountRolesList()}
      </If>
    </Segment>
  );
};

export default AccountRoles;
